module.exports = __webpack_public_path__ + "static/media/absolute_power.cc493c36.svg";